import { render, staticRenderFns } from "./CollaborativeListCell.vue?vue&type=template&id=347fb101&scoped=true"
import script from "./CollaborativeListCell.vue?vue&type=script&lang=js"
export * from "./CollaborativeListCell.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeListCell.vue?vue&type=style&index=0&id=347fb101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347fb101",
  null
  
)

export default component.exports